import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { CustomerSubscriptionFilterFormValues, CustomerSubscriptionFilters } from './types';

/** Single declaration of the Subscription filters, shared by api/drawer/page. `deviceId` is a
 *  multi-select (comma-separated device ids, backend `GetCustomerSubscriptionsDto.deviceId`);
 *  the rest are single-value, date bounds pass through as strings (`enumField` strips falsy).
 *  `search` participates only in the query params. */
const spec = defineFilterSpec<CustomerSubscriptionFilters, CustomerSubscriptionFilterFormValues>([
  text('search'),
  multiField('deviceId'),
  enumField('subscriptionStatus'),
  enumField('deviceType'),
  enumField('startDateFrom'),
  enumField('startDateTo'),
  enumField('endDateFrom'),
  enumField('endDateTo'),
]);

export const customerSubscriptionToListQuery = spec.toListQuery;
export const customerSubscriptionToDefaults = spec.toDefaults;
export const customerSubscriptionToFilters = spec.toFilters;
export const customerSubscriptionHasActiveFilters = spec.hasActiveFilters;
